var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentField,{tag:"component",attrs:{"parameter":_vm.parameter},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }